import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/admin/DashboardLayout'
import CustomerPortalLayout from '@/layout/customerPortal/CustomerPortalLayout'
//import AuthLayout from '@/layout/AuthLayout'
import store from '@/store'

Vue.use(Router)

/* ------------------------------------------------------------ */
let router = new Router({
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('../views/Login.vue'),
            meta: { requiresAuth: false, requiresAdmin: false },
        },
        {
            path: '/forgot_password',
            name: 'forgotPassword',
            component: () => import('../views/ForgotPassword.vue'),
            meta: { requiresAuth: false, requiresAdmin: false },
        },
        {
            path: '/reset_password',
            name: 'resetPassword',
            component: () => import('../views/ChangePassword.vue'),
            meta: { requiresAuth: false, requiresAdmin: false },
        },
        {
            path: '/customer_feedback',
            name: 'customerFeedback',
            component: () => import('../views/CustomerFeedback.vue'),
            meta: { requiresAuth: false, requiresAdmin: false },
        },
        {
            path: '/pdf_viewer',
            name: 'pdfViewer',
            component: () => import('../views/PdfViewer.vue'),
            meta: { requiresAuth: false, requiresAdmin: false },
        },
        {
            path: '/customer-portal/',
            name: 'customerLayout',
            redirect: 'CustomerPortalServiceRequests',
            component: CustomerPortalLayout,
            meta: { requiresAuth: true, requiresAdmin: false },
            children: [
                {
                    path: '/customer-portal/profile',
                    name: 'CustomerProfile',
                    component: () =>
                        import('@/views/CustomerPortal/CustomerProfile.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: false,
                    },
                },
                {
                    path: '/customer-portal/service-requests',
                    name: 'CustomerPortalServiceRequests',
                    component: () =>
                        import('@/views/CustomerPortal/ServiceRequests.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: false,
                    },
                },
                {
                    path: '/customer-portal/new-service',
                    name: 'CustomerPortalNewService',
                    component: () =>
                        import(
                            '@/views/CustomerPortal/CreateServiceRequest.vue'
                        ),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: false,
                    },
                },
                {
                    path: '/customer-portal/view-service/:id',
                    name: 'CustomerPortalViewService',
                    component: () =>
                        import('@/views/CustomerPortal/ServiceRequestView.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: false,
                    },
                },
            ],
        },
        {
            path: '/admin/',
            name: 'dashboardLayout',
            redirect: 'dashboard',
            component: DashboardLayout,
            meta: { requiresAuth: true, requiresAdmin: true },
            children: [
                {
                    path: '/admin/dashboard',
                    name: 'dashboard',
                    component: () => import('../views/Dashboard.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        icon: 'grid-1x2-fill',
                    },
                },
                {
                    path: '/admin/profile',
                    name: 'profile',
                    component: () => import('../views/UserProfile.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: '/admin/users',
                    name: 'users',
                    component: () => import('../views/Users.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'users',
                        icon: 'people-fill',
                    },
                },
                {
                    path: '/admin/users/:id',
                    name: 'viewUsers',
                    component: () => import('../views/Users/ViewUser.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },

                {
                    path: '/admin/activities',
                    name: 'orders',
                    component: () => import('../views/Orders/Orders.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'orders',
                        icon: 'box-seam',
                    },
                },

                {
                    path: '/admin/activities/:id',
                    name: 'viewOrder',
                    component: () => import('../views/Orders/ViewOrder.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: '/admin/orders/:id',
                    name: 'viewOrder',
                    component: () => import('../views/Orders/ViewOrder.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: '/admin/activity-type',
                    name: 'orderTypes',
                    component: () => import('../views/OrderType/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'orders',
                        icon: 'receipt',
                    },
                },
                {
                    path: '/admin/transaction-type',
                    name: 'transactionTypes',
                    component: () =>
                        import('../views/TransactionType/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'orders',
                        icon: 'receipt',
                    },
                },
                {
                    path: '/admin/item-type',
                    name: 'itemTypes',
                    component: () => import('../views/ItemType/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'inventory',
                        icon: 'tags',
                    },
                },
                {
                    path: '/admin/fleet',
                    name: 'fleet',
                    component: () => import('../views/Fleet/Fleet.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'users',
                        icon: 'truck',
                    },
                },
                {
                    path: '/admin/fleet/:id',
                    name: 'viewVehicle',
                    component: () => import('../views/Fleet/ViewVehicle.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },

                {
                    path: '/admin/roles',
                    name: 'roles',
                    component: () => import('../views/Roles/Roles.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'users',
                        icon: 'person-badge',
                    },
                },
                {
                    path: '/admin/roles/:id',
                    name: 'viewRole',
                    component: () => import('../views/Roles/ViewRole.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },

                {
                    path: '/admin/customers',
                    name: 'customers',
                    component: () => import('../views/Customers/Customers.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'customers',
                        icon: 'person-lines-fill',
                    },
                },
                {
                    path: '/admin/customers/:id',
                    name: 'viewCustomer',
                    props: true,
                    component: () =>
                        import('../views/Customers/ViewCustomer.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },

                {
                    path: '/admin/crm',
                    name: 'crmTasks',
                    component: () => import('../views/Asset/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'customers',
                        icon: 'nut',
                    },
                },
                {
                    path: '/admin/crm/:id',
                    name: 'crmView',
                    component: () => import('../views/Asset/Index.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },

                {
                    path: '/admin/request-categories',
                    name: 'requestCategories',
                    component: () =>
                        import('../views/RequestCategory/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'customers',
                        icon: 'arrows-fullscreen',
                    },
                },

                {
                    path: '/admin/reports',
                    name: 'reports',
                    component: () => import('../views/Reports/Reports.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'reports',
                        icon: 'clipboard-data',
                    },
                },
                {
                    path: '/admin/auditlogs',
                    name: 'auditLogs',
                    component: () => import('../views/AuditLogs/AuditLogs.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'reports',
                        icon: 'file-earmark-text',
                    },
                },
                {
                    path: '/admin/settings/company',
                    name: 'companySettings',
                    component: () =>
                        import('../views/Settings/CompanySettings.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'settings',
                        icon: 'gear',
                    },
                },

                {
                    path: '/admin/settings/asset-frequency',
                    name: 'assetFrequencies',
                    component: () =>
                        import('../views/Settings/AssetFrequencySettings.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'settings',
                        icon: 'gear',
                    },
                },

                {
                    path: '/admin/settings/company-notes',
                    name: 'companyNotes',
                    component: () =>
                        import('../views/Settings/CompanyNotes.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'settings',
                        icon: 'gear',
                    },
                },

                {
                    path: '/admin/settings/default-role',
                    name: 'defaultRole',
                    component: () =>
                        import('../views/Settings/DefaultRole.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'settings',
                        icon: 'gear',
                    },
                },

                {
                    path: '/admin/settings/task-types',
                    name: 'taskTypes',
                    component: () => import('../views/Settings/TaskTypes.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'settings',
                        icon: 'gear',
                    },
                },

                {
                    path: '/admin/settings/email-parts',
                    name: 'emailParts',
                    component: () => import('../views/Settings/EmailParts.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'settings',
                        icon: 'gear',
                    },
                },

                {
                    path: '/admin/settings/crm-settings',
                    name: 'crmSettings',
                    component: () =>
                        import('../views/Settings/CrmSettings.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'settings',
                        icon: 'gear',
                    },
                },

                {
                    path: '/admin/assets',
                    name: 'assets',
                    component: () => import('../views/Asset/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'assetMaintenance',
                        icon: 'nut',
                    },
                },
                {
                    path: '/admin/assets/:id',
                    name: 'assetView',
                    component: () => import('../views/Asset/Index.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },

                {
                    path: '/admin/asset-type',
                    name: 'assetTypes',
                    component: () => import('../views/AssetType/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'assetMaintenance',
                        icon: 'nut-fill',
                    },
                },
                {
                    path: '/admin/asset-vendor',
                    name: 'assetVendors',
                    component: () => import('../views/AssetVendor/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'assetMaintenance',
                        icon: 'shop',
                    },
                },
                {
                    path: '/admin/locations',
                    name: 'locations',
                    component: () => import('../views/Location/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'orders',
                        icon: 'building',
                    },
                },
                {
                    path: '/admin/locations/:id',
                    name: 'locationView',
                    component: () => import('../views/Location/Index.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: '/admin/activity-category',
                    name: 'orderCategories',
                    component: () => import('../views/OrderCategory/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'orderTemplates',
                        icon: 'arrows-fullscreen',
                    },
                },

                {
                    path: '/admin/section-items',
                    name: 'sectionItems',
                    component: () => import('../views/SectionItems/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'inventory',
                        icon: 'asterisk',
                    },
                },
                {
                    path: '/admin/transfer-section-items/',
                    name: 'transferSectionItems',
                    component: () => import('../views/SectionItems/transfer.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
                {
                    path: '/admin/inventory-usage',
                    name: 'inventoryUsage',
                    component: () =>
                        import('../views/InventoryUsage/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'inventory',
                        icon: 'asterisk',
                    },
                },

                {
                    path: '/admin/master-items',
                    name: 'masterItems',
                    component: () => import('../views/MasterItem/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'inventory',
                        icon: 'asterisk',
                    },
                },

                {
                    path: '/admin/master-items/:id',
                    name: 'masterItemView',
                    component: () => import('../views/MasterItem/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                    },
                },

                {
                    path: '/admin/activity-template',
                    name: 'orderTemplates',
                    component: () => import('../views/OrderTemplate/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'orderTemplates',
                        icon: 'arrows-move',
                    },
                },
                //////////reviews
                {
                    path: '/admin/reviews',
                    name: 'reviews',
                    component: () => import('../views/Checkoffs/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'review',
                        icon: 'check-all',
                    },
                },
                //////////review type
                {
                    path: '/admin/review-types',
                    name: 'reviewTypes',
                    component: () => import('../views/CheckoffTypes/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'review',
                        icon: 'stoplights',
                    },
                },
                ////review template
                {
                    path: '/admin/review-templates',
                    name: 'reviewTemplates',
                    component: () =>
                        import('../views/CheckoffTemplates/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                        group: 'review',
                        icon: 'stoplights-fill',
                    },
                },
                /////////////////////////
                {
                    path: '/admin/test',
                    name: 'test',
                    component: () => import('../views/Test.vue'),
                    meta: { requiresAuth: true, requiresAdmin: true },
                },
            ],
        },
    ],
})

router.beforeEach((to, from, next) => {
    console.log('route to', to)
    if (store.getters.authenticated && store.state.isAdmin) {
        if (to.matched.some(x => x.meta.requiresAdmin && x.meta.requiresAuth)) {
            next()
        } else {
            next('/admin/dashboard')
        }
    } else if (store.getters.authenticated) {
        if (
            to.matched.some(x => !x.meta.requiresAdmin && x.meta.requiresAuth)
        ) {
            next()
        } else {
            next('/customer-portal/service-requests')
        }
    } else {
        if (to.matched.some(x => !x.meta.requiresAuth)) {
            next()
        } else {
            next('/login')
        }
    }
})

export default router
